import { transformPropOrder } from '../../html/utils/transform.mjs';
import { number } from '../../../value/types/numbers/index.mjs';
import { px } from '../../../value/types/numbers/units.mjs';
const positionalKeys = new Set(["width", "height", "top", "left", "right", "bottom", "x", "y", "translateX", "translateY"]);
const isNumOrPxType = v => v === number || v === px;
const getPosFromMatrix = (matrix, pos) => parseFloat(matrix.split(", ")[pos]);
const getTranslateFromMatrix = (pos2, pos3) => (_bbox, _ref) => {
  let {
    transform
  } = _ref;
  if (transform === "none" || !transform) return 0;
  const matrix3d = transform.match(/^matrix3d\((.+)\)$/u);
  if (matrix3d) {
    return getPosFromMatrix(matrix3d[1], pos3);
  } else {
    const matrix = transform.match(/^matrix\((.+)\)$/u);
    if (matrix) {
      return getPosFromMatrix(matrix[1], pos2);
    } else {
      return 0;
    }
  }
};
const transformKeys = new Set(["x", "y", "z"]);
const nonTranslationalTransformKeys = transformPropOrder.filter(key => !transformKeys.has(key));
function removeNonTranslationalTransform(visualElement) {
  const removedTransforms = [];
  nonTranslationalTransformKeys.forEach(key => {
    const value = visualElement.getValue(key);
    if (value !== undefined) {
      removedTransforms.push([key, value.get()]);
      value.set(key.startsWith("scale") ? 1 : 0);
    }
  });
  return removedTransforms;
}
const positionalValues = {
  // Dimensions
  width: (_ref2, _ref3) => {
    let {
      x
    } = _ref2;
    let {
      paddingLeft = "0",
      paddingRight = "0"
    } = _ref3;
    return x.max - x.min - parseFloat(paddingLeft) - parseFloat(paddingRight);
  },
  height: (_ref4, _ref5) => {
    let {
      y
    } = _ref4;
    let {
      paddingTop = "0",
      paddingBottom = "0"
    } = _ref5;
    return y.max - y.min - parseFloat(paddingTop) - parseFloat(paddingBottom);
  },
  top: (_bbox, _ref6) => {
    let {
      top
    } = _ref6;
    return parseFloat(top);
  },
  left: (_bbox, _ref7) => {
    let {
      left
    } = _ref7;
    return parseFloat(left);
  },
  bottom: (_ref8, _ref9) => {
    let {
      y
    } = _ref8;
    let {
      top
    } = _ref9;
    return parseFloat(top) + (y.max - y.min);
  },
  right: (_ref10, _ref11) => {
    let {
      x
    } = _ref10;
    let {
      left
    } = _ref11;
    return parseFloat(left) + (x.max - x.min);
  },
  // Transform
  x: getTranslateFromMatrix(4, 13),
  y: getTranslateFromMatrix(5, 14)
};
// Alias translate longform names
positionalValues.translateX = positionalValues.x;
positionalValues.translateY = positionalValues.y;
export { isNumOrPxType, positionalKeys, positionalValues, removeNonTranslationalTransform };